<template>
  <span :class="['delta-pill', `is-${dir}`]" :title="label">
    <svg width="8" height="8" viewBox="0 0 8 8" aria-hidden="true">
      <path v-if="dir === 'up'" d="M4 1.2 7 6H1z" fill="currentColor" />
      <path v-else-if="dir === 'down'" d="M4 6.8 1 2h6z" fill="currentColor" />
      <circle v-else-if="dir === 'new'" cx="4" cy="4" r="2.2" fill="currentColor" />
      <rect v-else x="1" y="3.3" width="6" height="1.4" rx=".7" fill="currentColor" />
    </svg>
    <span class="tnum">{{ text }}</span>
  </span>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'DeltaPill',
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    up: {
      type: Boolean,
      default: null
    },
    fresh: {
      type: Boolean,
      default: false
    },
    suffix: {
      type: String,
      default: '%'
    },
    label: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const dir = computed(() => {
      if (props.fresh) return 'new'
      const v = Number(props.value ?? 0)
      if (!v) return 'flat'
      if (props.up === null) return v > 0 ? 'up' : 'down'
      return props.up ? 'up' : 'down'
    })

    const text = computed(() => {
      if (props.fresh) return '新增'
      const v = Math.abs(Number(props.value ?? 0))
      const sign = dir.value === 'up' ? '+' : dir.value === 'down' ? '−' : '±'
      return `${sign}${Number.isInteger(v) ? v : v.toFixed(1)}${props.suffix}`
    })

    return {
      dir,
      text
    }
  }
})
</script>

<style scoped lang="scss">
.delta-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 20px;
  padding: 0 8px 0 6px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  font-family: var(--font-mono);
  color: var(--ink-soft);
  background: rgba(var(--shade), 0.06);

  &.is-up {
    color: var(--leaf-text);
    background: var(--lime-soft);
  }
  &.is-down {
    color: var(--red-text);
    background: var(--red-soft);
  }
  &.is-new {
    color: var(--blue);
    background: var(--blue-soft);
  }
}
</style>
